const AUDIO_FOLDER_BY_CODE = {
  ru: 'Russian',
  uk: 'Ukrainian',
};

export const sanitizeAudioFolderName = (value = '') =>
  String(value || '')
    .replace(/\u00a0/g, ' ')
    .replace(/[\\/]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const isPublicFolderName = (value = '') => {
  const normalized = sanitizeAudioFolderName(value);
  return Boolean(normalized) && /^[\x20-\x7E]+$/.test(normalized);
};

export default function getLocaleAudioFolderName(
  locale = {},
  fallback = 'English'
) {
  const localeData =
    typeof locale === 'string' ? { name: locale } : locale || {};

  const code = sanitizeAudioFolderName(localeData.code).toLowerCase();
  const baseCode = code.split('-')[0];
  const mappedFolder = AUDIO_FOLDER_BY_CODE[code] || AUDIO_FOLDER_BY_CODE[baseCode];

  if (mappedFolder) return mappedFolder;

  const configuredFolder = [
    localeData.audioFolderName,
    localeData.name,
    localeData.displayName,
  ].find(isPublicFolderName);

  if (configuredFolder) return sanitizeAudioFolderName(configuredFolder);

  return sanitizeAudioFolderName(localeData.code || fallback) || 'English';
}
